// Author Liu Cui Cui
// Date 2023-10-12 00:10:23

class SithMesTpmProgramStatusTps {
constructor({
        id = null,
        tpsOperatorId = '',
        tpsOperatorName = '',
        tpsProgramName = '',
        tpsOperateSeq = '',
        tpsLocationId = '',
        tpsStartTime = '',
        tpsEndTime = '',
        tpsDuration = '',
        tpsProgramStatus = '',
        tpsDeviceCode = '',
        tpsDeviceSystemType = '',
        remark = ''}
= {}) {
    this.id = id;
    this.tpsOperatorId = tpsOperatorId;
    this.tpsOperatorName = tpsOperatorName;
    this.tpsProgramName = tpsProgramName;
    this.tpsOperateSeq = tpsOperateSeq;
    this.tpsLocationId = tpsLocationId;
    this.tpsStartTime = tpsStartTime;
    this.tpsEndTime = tpsEndTime;
    this.tpsDuration = tpsDuration;
    this.tpsProgramStatus = tpsProgramStatus;
    this.tpsDeviceCode = tpsDeviceCode;
    this.tpsDeviceSystemType = tpsDeviceSystemType;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesTpmProgramStatusTps();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tpsOperatorName',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.grid.tpsOperatorName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tpsDeptName',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.grid.tpsDeptName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tpsProjectCode',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.grid.tpsProjectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tpsItemName',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.grid.tpsItemName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tpsProgramName',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.grid.tpsProgramName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tpsOrderCode',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.grid.tpsOrderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'prdPpOperationName',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.grid.prdPpOperationName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tpsMstLocName',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.grid.tpsMstLocName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tpsStartTime',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.grid.tpsStartTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tpsEndTime',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.grid.tpsEndTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tpsDuration',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.grid.tpsDuration',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tpsProgramStatus',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.grid.tpsProgramStatus',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tpsDeviceCode',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.grid.tpsDeviceCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'tpsDeviceSystemType',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.grid.tpsDeviceSystemType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    tpsOperatorIdFilter : '',
    tpsOperatorNameFilter : '',
    tpsDeptNameFilter : '',
    tpsProjectCodeFilter : '',
    tpsItemNameFilter : '',
    tpsProgramNameFilter : '',
    tpsOrderCodeFilter : '',
    tpsOperateSeqFilter : '',
    prdPpOperationNameFilter : '',
    tpsLocationIdFilter : '',
    tpsMstLocNameFilter : '',
    tpsStartTimeRteFilter : '',
    tpsStartTimeLteFilter : '',
    tpsEndTimeRteFilter : '',
    tpsEndTimeLteFilter : '',
    tpsDurationFilter : '',
    tpsDurationGreaterFilter : '',
    tpsProgramStatusFilter : '',
    tpsDeviceCodeFilter : '',
    tpsDeviceSystemTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'tpsOperatorIdFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsOperatorId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'tpsOperatorNameFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsOperatorName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsDeptNameFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsDeptName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsProjectCodeFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsProjectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsItemNameFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsItemName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsProgramNameFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsProgramName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsOrderCodeFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsOrderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'prdPpOperationNameFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.prdPpOperationName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsMstLocNameFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsMstLocName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsStartTimeRteFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsStartTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsStartTimeLteFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsStartTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsEndTimeRteFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsEndTimeRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsEndTimeLteFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsEndTimeLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsDurationFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsDuration',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsDurationGreaterFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsDurationGreater',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsProgramStatusFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsProgramStatus',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsDeviceCodeFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsDeviceCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsDeviceSystemTypeFilter',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.filter.tpsDeviceSystemType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'tpsOperatorName',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.entity.tpsOperatorName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"tpsOperatorId":"id"}'
                }
        },
        {
        key: 'tpsProgramName',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.entity.tpsProgramName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsOperateSeq',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.entity.tpsOperateSeq',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdPpOperation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'tpsLocationId',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.entity.tpsLocationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'tpsStartTime',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.entity.tpsStartTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsEndTime',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.entity.tpsEndTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsDuration',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.entity.tpsDuration',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsProgramStatus',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.entity.tpsProgramStatus',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsDeviceCode',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.entity.tpsDeviceCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'tpsDeviceSystemType',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.entity.tpsDeviceSystemType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.tpm.sithMesTpmProgramStatusTps.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesTpmProgramStatusTps, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
